import React from 'react';
import { connect } from 'react-redux';
import { Accordion, Select, Tooltip } from '@cimpress/react-components';
import { toSelectOption } from 'src/util/misc';
import ErrorIcon from 'src/components/icons/ErrorIcon';
import { Document } from '../documents/slice';

export interface SurfaceConfiguration {
    variableAttribute: string;
    documents: string[];
    values: Record<string, unknown>;
    isValid?: boolean;
    errorMessage?: string;
}

interface Props {
    configuration: SurfaceConfiguration;
    updateConfiguration: (configuration: SurfaceConfiguration) => void;
    removeConfiguration: () => void;
    documents: Document[];
    getErrorMessage: (configuration: SurfaceConfiguration) => string;
}

const EachSurfaceVariable = (props: Props) => {
    const { configuration, removeConfiguration, updateConfiguration, documents, getErrorMessage } = props;

    const deleteConfiguration = () => removeConfiguration();

    const onConfigurationChangeHandler = (key: string, value: unknown) => {
        const newConfig = { ...configuration, [key]: value };
        const errorMessage = getErrorMessage(newConfig);
        updateConfiguration({ ...newConfig, errorMessage });
    };

    return (
        <Accordion
            className='product-variable-options-list'
            defaultOpen={true}
            title={
                <div className='layers-header' data-testid={`surface-variable-${configuration.variableAttribute}-item`}>
                    <div className='layers-header__text truncate_label' title={configuration.variableAttribute}>
                        {configuration.errorMessage && (
                            <Tooltip direction='top' contents={configuration.errorMessage}>
                                <ErrorIcon />
                            </Tooltip>
                        )}
                        {configuration.variableAttribute}
                    </div>
                    <button onClick={deleteConfiguration}>
                        <img className='iconLg' src='https://static.ux.cimpress.io/assets/icons/bin-1-f.svg' />
                    </button>
                </div>
            }>
            <div className='accordion-body-wrapper'>
                <p>
                    <b>Select All Customizable Area That Apply</b>
                </p>
                <div data-testid={`surface-variable-${configuration.variableAttribute}-document-selector`}>
                    <Select
                        // `toSelectOption`'s declared return type also covers its single-value (string input)
                        // overload-less branch; these calls always pass an array, so asserting the real array
                        // shape here instead of the loose/ambiguous union.
                        options={toSelectOption(documents.map((doc) => doc.id)) as { label: string; value: string }[]}
                        label='Select Document(s)'
                        value={
                            configuration.documents?.length > 0
                                ? (toSelectOption(configuration.documents) as { label: string; value: string }[])
                                : undefined
                        }
                        onChange={(chosenOption) =>
                            onConfigurationChangeHandler(
                                'documents',
                                chosenOption?.map((selected: { value: string }) => selected.value),
                            )
                        }
                        menuPortalTarget={document.body}
                        isMulti={true}
                    />
                </div>
            </div>
        </Accordion>
    );
};

export default connect()(EachSurfaceVariable);
